module.exports = __webpack_public_path__ + "static/img/smartCitiesTech.caaaf724.png";